<template>
  <div class="xcard">
    <!-- <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras
    </v-btn> -->
    <!-- <p class="my-1">
      <b>ID/Sede:</b> {{ this.$store.state.CARGO.sede.id }} - {{ this.$store.state.CARGO.sede.nombre }}
    </p>
    <b>Sucursales: </b>
    <v-progress-linear indeterminate v-if="loadingsucursales" class="green" />
    <v-row no-gutters>
      <v-col v-for="(se, ind) in sucursales" :key="ind" class="mb-0 pl-4" sm="3">
        <p class="mb-0">
          <small>
            <b> [Nro. {{ se.sucursal.numero_sucursal }}]</b> nit: {{ se.sucursal.nro_nit }}
          </small>
        </p>
        <p v-if="se.punto_venta.nombre">
          <small>
            <b>[{{ se.punto_venta.codigo_punto_venta }}]</b> {{ se.punto_venta.nombre }} -
            {{ se.punto_venta.descripcion }}
          </small>
        </p>
        <p v-else class="ma-0">
          <small class="ml-0"><b>Sin punto de venta</b></small>
        </p>
      </v-col>
    </v-row> -->
    <template>
      <v-data-table :headers="headers" :items="desserts" :loading="loading" sort-by="calories" class="elevation-1">
        <template v-slot:top>
          <v-toolbar flat>
            <v-toolbar-title> Notas de Debito - Credito </v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-btn class="green darken-2 white--text" @click="editItem()">
              <v-icon small class="mr-2">
                mdi-plus
              </v-icon>
              Registrar Nota
            </v-btn>
          </v-toolbar>
        </template>

        <!-- <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn small tile icon color="primary" dark v-bind="attrs" v-on="on">
                <v-icon small @click="editItem(item)">
                  mdi-pencil
                </v-icon>
              </v-btn>
            </template>
            <span>Editar Sucursal</span>
          </v-tooltip>
        </template> -->
      </v-data-table>
    </template>

    <Registrar ref="registrar" />
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import Registrar from '@/views/recibos/notas/registrar.vue';
  export default {
    data: () => ({
      dialog: false,
      dialogDelete: false,
      loadingsucursales: false,
      loading: false,
      sucursales: [],
      headers: [
        { text: 'Nit', value: 'nro_nit' },
        { text: 'Direccion', value: 'direccion' },
        { text: 'Telefono', value: 'telefono' },
        { text: 'Ciudad', value: 'ciudad' },
        { text: 'Municipio', value: 'municipio' },
        { text: 'Opciones', value: 'actions', sortable: false, width: 120 },
      ],
      desserts: [],
    }),

    components: { Registrar },
    watch: {
      '$store.state.CARGO.sede': function() {
        this.getSucursalesBySede();
      },
    },
    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.getSucursalesBySede();
        /*let vue = this;
        this.loading = true;
        var config = {
          method: 'get',
          url: `${process.env.VUE_APP_API_REST}/api/v1/esam/sucursales`,
          headers: {},
        };

        axios(config)
          .then(function(response) {
            let data = response.data.data;
            vue.desserts = data;
            vue.loading = false;
          })
          .catch(function(error) {
            vue.loading = false;
            window.console.log(error);
          });*/
      },
      getSucursalesBySede() {
        let sedeid = this.$store.state.CARGO.idsede;
        let vue = this;
        this.sucursales = [];
        vue.loadingsucursales = true;

        let url = `${process.env.VUE_APP_API_REST}/api/v1/esam/sedessucursales?sedeID=${sedeid}`;
        xaxios
          .get(url)
          .then(function(response) {
            let data = response.data.data;
            vue.sucursales = data;
            vue.loadingsucursales = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loadingsucursales = false;
          });
      },

      newregsucursal() {
        this.initialize();
      },
      editItem() {
        let sucursal = this.sucursales[0];
        this.$refs.registrar.showThisView(sucursal);
      },
    },
  };
</script>
